export const excludeVerboxFromOutsideClick = () => {
  const chatWidget = document.querySelector('.online-chat-widget-draggable-wrapper');
  if (chatWidget && !Object.hasOwn(chatWidget.dataset, 'excludeOutsideClick')) {
    chatWidget.dataset.excludeOutsideClick = '';
  }
};
